export const hu = {
  brand: {
    tagline: "Modern társasházak Győrben",
  },
  nav: {
    home: "Kezdőlap",
    about: "Rólunk",
    projects: "Projektek",
    contact: "Kapcsolat",
  },
  home: {
    heroTitle: "Otthon, ami értéket teremt.",
    heroSubtitle:
      "Tervezzük, építjük és értékesítjük az új generációs társasházakat. Minőség, megbízhatóság, átlátható folyamatok.",
    ctaProjects: "Megnézem a projekteket",
    ctaContact: "Kapcsolatfelvétel",
    servicesTitle: "Szolgáltatásaink",
    services: {
      planning: {
        title: "Tervezés",
        text: "Komplett építészeti és belsőépítészeti tervezés, energetikai tanúsítással.",
      },
      construction: {
        title: "Kivitelezés",
        text: "Saját kivitelezői csapat, ellenőrzött minőség, határidőre.",
      },
      sales: {
        title: "Értékesítés",
        text: "Közvetlen értékesítés a fejlesztőtől, hitelügyintézés segítséggel.",
      },
    },
    projectsTitle: "Aktuális projektjeink",
    projectsCta: "Összes projekt megtekintése",
  },
  about: {
    title: "Rólunk",
    intro:
      "Cégünk több mint 20 éves szakmai tapasztalattal rendelkezik az építőiparban. Hiszünk abban, hogy egy otthon nem csak épület — hanem hosszú távú befektetés és érzelmi érték.",
    visionTitle: "Vízió",
    visionText:
      "Olyan társasházakat építünk, amelyek 30 év múlva is büszkén állnak: minőségi anyagok, modern energetika, átgondolt elrendezés.",
    valuesTitle: "Értékeink",
    values: {
      quality: "Minőség kompromisszum nélkül",
      transparency: "Átlátható kommunikáció és árazás",
      reliability: "Vállalt határidők, vállalt szavak",
    },
  },
  projects: {
    title: "Projektjeink",
    subtitle: "Aktuális és korábbi társasház-fejlesztéseink.",
    empty: "Jelenleg nincs publikált projekt.",
    statusLabel: {
      planning: "Tervezés alatt",
      construction: "Kivitelezés alatt",
      sales: "Értékesítés alatt",
      completed: "Befejezett",
    },
    detail: {
      gallery: "Galéria",
      floorplans: "Alaprajzok",
      units: "Lakások",
      unitsTable: {
        label: "Lakás",
        floor: "Emelet",
        rooms: "Szoba",
        area: "Terület",
        price: "Ár",
        status: "Státusz",
      },
      unitStatus: {
        available: "Szabad",
        reserved: "Foglalt",
        sold: "Eladott",
      },
      interest: "Érdekel ez a lakás",
      backToProjects: "← Vissza a projektekhez",
      expectedCompletion: "Várható átadás",
      address: "Helyszín",
    },
  },
  contact: {
    title: "Kapcsolat",
    subtitle: "Vegye fel velünk a kapcsolatot — válaszolunk 24 órán belül.",
    form: {
      submit: "Üzenet küldése",
      success: "Köszönjük! Az üzenetét megkaptuk, hamarosan jelentkezünk.",
      error: "Hiba történt a küldés közben. Kérjük próbálja újra.",
      sending: "Küldés...",
    },
    sidebar: {
      contactBlock: "Elérhetőségeink",
      address: "Cím",
      phone: "Telefon",
      email: "Email",
    },
  },
  footer: {
    tagline: "Modern társasházak Győrben",
    rights: "Minden jog fenntartva",
    privacy: "Adatvédelem",
    imprint: "Impresszum",
  },
  common: {
    loading: "Betöltés...",
    error: "Hiba történt",
    notFound: "Az oldal nem található",
    backHome: "Vissza a kezdőlapra",
  },
  admin: {
    login: {
      title: "Admin bejelentkezés",
      email: "Email",
      password: "Jelszó",
      submit: "Bejelentkezés",
      error: "Hibás email vagy jelszó",
    },
    nav: {
      dashboard: "Áttekintés",
      projects: "Projektek",
      formBuilder: "Form szerkesztő",
      messages: "Üzenetek",
      logout: "Kijelentkezés",
    },
    dashboard: {
      title: "Áttekintés",
      newMessages: "Új üzenetek",
      activeProjects: "Aktív projektek",
      totalUnits: "Összes lakás",
    },
    projects: {
      title: "Projektek",
      new: "Új projekt",
      noProjects: "Még nincs projekt felvéve.",
    },
    project: {
      newTitle: "Új projekt",
      basics: "Alapadatok",
      slug: "URL slug",
      slugHelp: "URL-barát név (csak kisbetű, szám, kötőjel)",
      name: "Név",
      shortDescription: "Rövid leírás",
      description: "Részletes leírás",
      address: "Cím",
      status: "Státusz",
      expectedCompletion: "Várható átadás",
      isPublished: "Publikálva",
      sortOrder: "Sorrend",
      coverImage: "Borítókép",
      gallery: "Galéria",
      floorplans: "Alaprajzok",
      units: "Lakások",
      saveBasics: "Alapadatok mentése",
      addUnit: "Új lakás",
      uploadImage: "Kép feltöltése",
      uploadFloorplan: "Alaprajz feltöltése",
      delete: "Törlés",
    },
    formBuilder: {
      title: "Kapcsolat form szerkesztő",
      newField: "Új mező",
      key: "Mező kulcsa (gépi név)",
      label: "Címke",
      placeholder: "Placeholder",
      helpText: "Súgó szöveg",
      type: "Típus",
      required: "Kötelező",
      options: "Opciók (select-hez, soronként)",
      isActive: "Aktív (megjelenik a formon)",
      sortOrder: "Sorrend",
      types: {
        text: "Szöveg",
        email: "Email",
        tel: "Telefon",
        textarea: "Hosszú szöveg",
        select: "Legördülő",
        checkbox: "Jelölőnégyzet",
      },
    },
    messages: {
      title: "Beérkezett üzenetek",
      empty: "Nincs beérkezett üzenet.",
      markRead: "Olvasottnak jelöl",
      markUnread: "Olvasatlannak jelöl",
      archive: "Archivál",
      delete: "Törlés",
      showArchived: "Archívum",
      from: "Forrás",
      project: "Projekt",
      unit: "Lakás",
    },
  },
};

export type TranslationResource = typeof hu;
